<template>
  <div class="container">
    <div class="col-12 text-left">
      <router-link :to="{ name: 'TagsDashboard', }" class="">
        <button class="btn mx-1 rounded-pill btn-primary">تگ ها</button>
      </router-link>
    </div>

    <tag-form :submit-function="createTag"/>
  </div>
</template>

<script>

import TagForm from "@/plugin/components/dashboard/Tag/TagForm.vue";
import {mapActions} from "vuex";

export default {
  name: "CreateTag",
  components: {TagForm},
  methods: {
    ...mapActions({
      createTag: 'Tag/createTag'
    })
  }

}
</script>

<style scoped>

</style>